/** Formatting helpers. Money uses the deal currency; Indian rupees group as lakhs and crores. */
import { displayPrefs, formatDay } from "./time";

export { fromLocalInput, toLocalInput } from "./time";

export function money(amount: number, currency: string, compact = false): string {
  const locale = currency === "INR" ? "en-IN" : displayPrefs().locale;
  return new Intl.NumberFormat(locale, {
    style: "currency", currency, maximumFractionDigits: compact ? 1 : 0,
    notation: compact ? "compact" : "standard",
  }).format(amount);
}

/** Calendar dates as they are; instants in the user's zone. */
export const shortDate = (iso: string | null): string => formatDay(iso);

export function relative(iso: string): string {
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(displayPrefs().locale, { numeric: "auto" });
  if (abs < 60) return rtf.format(Math.round(diff), "second");
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  return rtf.format(Math.round(diff / 86400), "day");
}

export const titleCase = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).replace(/_/g, " ");
